export function matchPctTone(pct) {
  if (pct >= 75) {
    return {
      border: 'border-emerald-400/55',
      text: 'text-emerald-200',
      bg: 'bg-emerald-950/50',
      glow: 'shadow-[0_0_12px_rgba(52,211,153,0.28)]',
    };
  }
  if (pct >= 45) {
    return {
      border: 'border-cyan-400/60',
      text: 'text-cyan-200',
      bg: 'bg-cyan-950/45',
      glow: 'shadow-[0_0_12px_rgba(34,211,238,0.32)]',
    };
  }
  return {
    border: 'border-amber-400/55',
    text: 'text-amber-200',
    bg: 'bg-amber-950/40',
    glow: 'shadow-[0_0_12px_rgba(251,191,36,0.26)]',
  };
}
